/**
 * Makes first letter capitalise
 * @param str
 */
export const capitalize = (str: string): string => str[0].toUpperCase() + str.substring(1)
